import UsersModal from './UsersModal';

export default UsersModal;
